export const PAIE_FIELDS_TO_ROUND = [
  'brut_base',
  'sursalaire',
  'prime',
  'prime_extra',
  'prime_anciennete',
  'transport',
  'logement',
  'fonction_ind',
  'ind_vehicule_cnss',
  'ind_representation',
  'ind_blanchissage',
  'ind_vehicule_nc',
  'autres',
  'avantage_nature',
  'treizieme_mois',
  'hsup_total',
  'cat1_total',
  'cat2_total',
  'cat3_total',
  'brut_imposable',
  'base_cnss',
  'base_cnamgs',
  'base_tcs',
  'cnss_pf_emp',
  'cnss_rp_emp',
  'cnss_vid_emp',
  'cnss_vid_sal',
  'cnamgs_emp',
  'cnamgs_fam_emp',
  'cnamgs_sal',
  'cfp_emp',
  'fnh_emp',
  'fgtls_emp',
  'tcs',
  'total_charges_emp',
  'cout_employeur',
  'abattement',
  'net_imposable',
  'irpp_mensuel',
  'net_a_payer',
  'avance',
] as const;
